const AcquiringActionTypes = {
    START_GET_DEFAULT_CARD_ACQUIRING: 'START_GET_DEFAULT_CARD_ACQUIRING',
    SUCCESS_GET_DEFAULT_CARD_ACQUIRING: 'SUCCESS_GET_DEFAULT_CARD_ACQUIRING',
    FAILURE_GET_DEFAULT_CARD_ACQUIRING: 'FAILURE_GET_DEFAULT_CARD_ACQUIRING',
    FINISH_GET_DEFAULT_CARD_ACQUIRING: 'FINISH_GET_DEFAULT_CARD_ACQUIRING',

    START_GET_ACCOUNTS_ACQUIRING: 'START_GET_ACCOUNTS_ACQUIRING',
    SUCCESS_GET_ACCOUNTS_ACQUIRING: 'SUCCESS_GET_ACCOUNTS_ACQUIRING',
    FAILURE_GET_ACCOUNTS_ACQUIRING: 'FAILURE_GET_ACCOUNTS_ACQUIRING',
    FINISH_GET_ACCOUNTS_ACQUIRING: 'FINISH_GET_ACCOUNTS_ACQUIRING',

    START_ACQUIRING_TRANSFERS_DOWNLOAD: 'START_ACQUIRING_TRANSFERS_DOWNLOAD',
    SUCCESS_ACQUIRING_TRANSFERS_DOWNLOAD: 'SUCCESS_ACQUIRING_TRANSFERS_DOWNLOAD',
    FAILURE_ACQUIRING_TRANSFERS_DOWNLOAD: 'FAILURE_ACQUIRING_TRANSFERS_DOWNLOAD',
    FINISH_ACQUIRING_TRANSFERS_DOWNLOAD: 'FINISH_ACQUIRING_TRANSFERS_DOWNLOAD',

    START_CARD_ACQUIRING_MERCHANTS: 'START_CARD_ACQUIRING_MERCHANTS',
    SUCCESS_CARD_ACQUIRING_MERCHANTS: 'SUCCESS_CARD_ACQUIRING_MERCHANTS',
    FAILURE_CARD_ACQUIRING_MERCHANTS: 'FAILURE_CARD_ACQUIRING_MERCHANTS',
    FINISH_CARD_ACQUIRING_MERCHANTS: 'FINISH_CARD_ACQUIRING_MERCHANTS',

    START_GET_CARD_ACQUIRING_SETTLEMENTS: 'START_GET_CARD_ACQUIRING_SETTLEMENTS',
    SUCCESS_GET_CARD_ACQUIRING_SETTLEMENTS: 'SUCCESS_GET_CARD_ACQUIRING_SETTLEMENTS',
    FAILURE_GET_CARD_ACQUIRING_SETTLEMENTS: 'FAILURE_GET_CARD_ACQUIRING_SETTLEMENTS',
    FINISH_GET_CARD_ACQUIRING_SETTLEMENTS: 'FINISH_GET_CARD_ACQUIRING_SETTLEMENTS',

    START_GET_CARD_ACQUIRING_CHARGES: 'START_GET_CARD_ACQUIRING_CHARGES',
    SUCCESS_GET_CARD_ACQUIRING_CHARGES: 'SUCCESS_GET_CARD_ACQUIRING_CHARGES',
    FAILURE_GET_CARD_ACQUIRING_CHARGES: 'FAILURE_GET_CARD_ACQUIRING_CHARGES',
    FINISH_GET_CARD_ACQUIRING_CHARGES: 'FINISH_GET_CARD_ACQUIRING_CHARGES',

    START_ACQUIRING_CREDENTIALS_REGENERATE: 'START_ACQUIRING_CREDENTIALS_REGENERATE',
    SUCCESS_ACQUIRING_CREDENTIALS_REGENERATE: 'SUCCESS_ACQUIRING_CREDENTIALS_REGENERATE',
    FAILURE_ACQUIRING_CREDENTIALS_REGENERATE: 'FAILURE_ACQUIRING_CREDENTIALS_REGENERATE',
    FINISH_ACQUIRING_CREDENTIALS_REGENERATE: 'FINISH_ACQUIRING_CREDENTIALS_REGENERATE',

    START_ACQUIRING_CHARGES_DOWNLOAD: 'START_ACQUIRING_CHARGES_DOWNLOAD',
    SUCCESS_ACQUIRING_CHARGES_DOWNLOAD: 'SUCCESS_ACQUIRING_CHARGES_DOWNLOAD',
    FAILURE_ACQUIRING_CHARGES_DOWNLOAD: 'FAILURE_ACQUIRING_CHARGES_DOWNLOAD',
    FINISH_ACQUIRING_CHARGES_DOWNLOAD: 'FINISH_ACQUIRING_CHARGES_DOWNLOAD',

    START_SETTLEMENTS_PDF_DOWNLOAD: 'START_SETTLEMENTS_PDF_DOWNLOAD',
    SUCCESS_SETTLEMENTS_PDF_DOWNLOAD: 'SUCCESS_SETTLEMENTS_PDF_DOWNLOAD',
    FAILURE_SETTLEMENTS_PDF_DOWNLOAD: 'FAILURE_SETTLEMENTS_PDF_DOWNLOAD',
    FINISH_SETTLEMENTS_PDF_DOWNLOAD: 'FINISH_SETTLEMENTS_PDF_DOWNLOAD',

    START_SETTLEMENT_PDF_DOWNLOAD: 'START_SETTLEMENT_PDF_DOWNLOAD',
    SUCCESS_SETTLEMENT_PDF_DOWNLOAD: 'SUCCESS_SETTLEMENT_PDF_DOWNLOAD',
    FAILURE_SETTLEMENT_PDF_DOWNLOAD: 'FAILURE_SETTLEMENT_PDF_DOWNLOAD',
    FINISH_SETTLEMENT_PDF_DOWNLOAD: 'FINISH_SETTLEMENT_PDF_DOWNLOAD',

    START_CHARGES_RECEIPT_PDF: 'START_CHARGES_RECEIPT_PDF',
    SUCCESS_CHARGES_RECEIPT_PDF: 'SUCCESS_CHARGES_RECEIPT_PDF',
    FAILURE_CHARGES_RECEIPT_PDF: 'FAILURE_CHARGES_RECEIPT_PDF',
    FINISH_CHARGES_RECEIPT_PDF: 'FINISH_CHARGES_RECEIPT_PDF',

    START_SETTLEMENTS_CSV_DOWNLOAD: 'START_SETTLEMENTS_CSV_DOWNLOAD',
    SUCCESS_SETTLEMENTS_CSV_DOWNLOAD: 'SUCCESS_SETTLEMENTS_CSV_DOWNLOAD',
    FAILURE_SETTLEMENTS_CSV_DOWNLOAD: 'FAILURE_SETTLEMENTS_CSV_DOWNLOAD',
    FINISH_SETTLEMENTS_CSV_DOWNLOAD: 'FINISH_SETTLEMENTS_CSV_DOWNLOAD',

    START_SETTLEMENTS_PERIOD_SUMMARY_DOWNLOAD: 'START_SETTLEMENTS_PERIOD_SUMMARY_DOWNLOAD',
    SUCCESS_SETTLEMENTS_PERIOD_SUMMARY_DOWNLOAD: 'SUCCESS_SETTLEMENTS_PERIOD_SUMMARY_DOWNLOAD',
    FAILURE_SETTLEMENTS_PERIOD_SUMMARY_DOWNLOAD: 'FAILURE_SETTLEMENTS_PERIOD_SUMMARY_DOWNLOAD',
    FINISH_SETTLEMENTS_PERIOD_SUMMARY_DOWNLOAD: 'FINISH_SETTLEMENTS_PERIOD_SUMMARY_DOWNLOAD',

    START_PAYMENT_GATEWAY_MERCHANTS: 'START_PAYMENT_GATEWAY_MERCHANTS',
    SUCCESS_PAYMENT_GATEWAY_MERCHANTS: 'SUCCESS_PAYMENT_GATEWAY_MERCHANTS',
    FAILURE_PAYMENT_GATEWAY_MERCHANTS: 'FAILURE_PAYMENT_GATEWAY_MERCHANTS',
    FINISH_PAYMENT_GATEWAY_MERCHANTS: 'FINISH_PAYMENT_GATEWAY_MERCHANTS',
}

export default AcquiringActionTypes
